import React from 'react';
import axios from 'axios';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { AGRO_STATUS_CONFIG as STATUS_CONFIG } from './agroStatus';
import { finiteNumber, formatNumber } from './taskMapData';
const ROWS = [
    { key: 'ph', label: 'Кислотность (pH)', unit: '', classified: true },
    { key: 'humus', label: 'Гумус', unit: '%', classified: true },
    { key: 'nitrogen', label: 'Азот (N)', unit: 'мг/кг', classified: true },
    { key: 'phosphorus', label: 'Фосфор (P)', unit: 'мг/кг', classified: true },
    { key: 'potassium', label: 'Калий (K)', unit: 'мг/кг', classified: true },
    { key: 'sulfur', label: 'Подвижная сера (S)', unit: 'мг/кг', classified: true },
    { key: 'eko', label: 'Ёмкость катионного обмена (ЕКО)', unit: '', classified: false },
    { key: 'organic', label: 'Органическое вещество (Органика)', unit: '%', classified: false },
];
export default function AgrochemBlock({ token, fieldId, season }) {
    const [summary, setSummary] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);
    React.useEffect(() => {
        let active = true;
        setLoading(true);
        setError(false);
        setSummary(null);
        axios.get(`/agrochemical/dashboard/${fieldId}/${season}`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((response) => {
            if (active)
                setSummary(response.data);
        }).catch(() => {
            if (active)
                setError(true);
        }).finally(() => {
            if (active)
                setLoading(false);
        });
        return () => { active = false; };
    }, [fieldId, season, token]);
    if (loading) {
        return React.createElement(Typography, { "data-onboarding-state": "loading", variant: "caption", color: "text.secondary", sx: { p: 2, display: 'block' } }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0430\u0433\u0440\u043E\u0445\u0438\u043C\u0438\u0438\u2026");
    }
    if (error) {
        return React.createElement(Typography, { "data-onboarding-state": "error", variant: "caption", color: "text.secondary", sx: { p: 2, display: 'block' } }, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0430\u0433\u0440\u043E\u0445\u0438\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0438.");
    }
    if (!summary || !summary.date) {
        return (React.createElement(Typography, { "data-onboarding-state": "empty", variant: "caption", color: "text.secondary", sx: { p: 2, display: 'block' } }, "\u0410\u043D\u0430\u043B\u0438\u0437 \u043F\u043E\u0447\u0432\u044B \u0437\u0430 \u044D\u0442\u043E\u0442 \u0441\u0435\u0437\u043E\u043D \u043D\u0435 \u0432\u043D\u0435\u0441\u0451\u043D \u2014 \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u00AB\u0412\u043D\u0435\u0441\u0435\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445\u00BB"));
    }
    const formattedDate = new Date(summary.date).toLocaleDateString('ru-RU');
    return (React.createElement(Box, { sx: { p: 2, minWidth: 0, flex: '0 0 auto', display: 'flex', flexDirection: 'column' } },
        React.createElement(Typography, { variant: "subtitle2", fontWeight: 700, sx: { flexShrink: 0 } },
            "\u0410\u0433\u0440\u043E\u0445\u0438\u043C\u0438\u044F (\u0430\u043D\u0430\u043B\u0438\u0437 ",
            formattedDate,
            ", ",
            summary.sample_count,
            " \u043F\u0440\u043E\u0431",
            summary.sample_count === 1 ? 'а' : summary.sample_count < 5 ? 'ы' : '',
            ")"),
        React.createElement(Stack, { spacing: 0.75, sx: { mt: 1, mb: 1, flex: 1, justifyContent: 'space-evenly' } }, ROWS.map((row) => {
            const value = summary.values[row.key];
            const status = summary.statuses[row.key];
            const cfg = finiteNumber(value) && row.classified && status ? STATUS_CONFIG[status] : null;
            return (React.createElement(Stack, { key: row.key, direction: "row", justifyContent: "space-between", alignItems: "center" },
                React.createElement(Typography, { variant: "body2" }, row.label),
                React.createElement(Stack, { direction: "row", spacing: 1, alignItems: "center" },
                    React.createElement(Typography, { variant: "body2", fontWeight: 600 },
                        formatNumber(value),
                        finiteNumber(value) && row.unit ? ` ${row.unit}` : ''),
                    cfg && (React.createElement(Chip, { label: cfg.label, size: "small", sx: { color: cfg.color, backgroundColor: cfg.bg, fontWeight: 600, height: 20 } })))));
        })),
        React.createElement(Box, { sx: { mt: 1.5, p: 1.5, backgroundColor: '#f5f5f0', borderRadius: 1 } }, summary.recommendations.map((text, i) => (React.createElement(Typography, { key: i, variant: "caption", display: "block", color: "text.secondary" }, text))))));
}
